<template>
  <div class="row">
    <div class="col-md-10 offset-md-1">
      <div class="question" v-html="component.data.question.html"></div>
      <div class="answers">
        <div
          class="mb-3 form-check"
          v-for="(answer, index) in answers"
          :key="index"
        >
          <input
            :ref="`answer${index}`"
            type="checkbox"
            class="form-check-input"
            @change="answerChanged"
            v-model="answer.selected"
          />
          <label class="form-check-label">{{ answer.label }}</label>
        </div>
        <div class="my-3" v-if="showSolution">
          <div v-if="answerIsValid" class="text-success">
            {{ t.correct }}
          </div>
          <div v-else class="text-warning">
            {{ t.wrong_answer }}
          </div>
        </div>
        <button class="btn btn-primary btn-sm" @click.prevent="check">
          {{ t.check_my_answer }}
        </button>
        <button class="btn btn-outline-secondary btn-sm" @click.prevent="toggleHint">
          <i class="fas fa-lightbulb"></i>
        </button>
      </div>
      <div
        class="solution mt-3"
        v-html="component.data.solution.html"
        v-if="showHint"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component', 't'],
  data() {
    return {
      answers: this.component.data.answers.map(a => {
        return {...a, selected: false}
      }),
      validated: null,
      showSolution: false,
      showHint: false,
    }
  },
  computed: {
    answerIsValid() {
      return this.answers.every((answer, index) => {
        return answer.selected === answer.correct
      })
    },
  },
  methods: {
    answerChanged() {
      this.showSolution = false
    },
    check() {
      this.showSolution = true
    },
    toggleHint() {
      this.showHint = !this.showHint
    },
  },
}
</script>

<style></style>
